var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.description
    ? _c(
        "v-tooltip",
        {
          attrs: { "open-delay": "0", "close-delay": "0", right: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "v-chip",
                      _vm._g(
                        {
                          attrs: {
                            small: "",
                            color: _vm.color,
                            "text-color": _vm.textColor
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("click")
                            }
                          }
                        },
                        on
                      ),
                      [
                        _vm.icon
                          ? _c(
                              "v-avatar",
                              { attrs: { color: "" + _vm.color } },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(_vm._s(_vm.icon))
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v("\n      " + _vm._s(_vm.status) + "\n    ")
                      ],
                      1
                    )
                  ]
                }
              }
            ],
            null,
            false,
            1626014967
          )
        },
        [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.description))])]
      )
    : _c(
        "v-chip",
        {
          attrs: {
            small: "",
            disabled: "",
            color: _vm.color,
            "text-color": _vm.textColor
          }
        },
        [
          _vm.icon
            ? _c(
                "v-avatar",
                { attrs: { color: "" + _vm.color } },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(_vm._s(_vm.icon))
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v("\n  " + _vm._s(_vm.status) + "\n")
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20629397", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20629397","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Users/Status/Chip.vue
// module id = null
// module chunks = 